// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"30":"90d343af","768":"68edfefd","829":"e53af7c1","873":"81dba6bd"}[chunkId] + ".chunk.css";
};